/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkstreamsRouteRouteImport } from './routes/workstreams.route'
import { Route as VersionRouteRouteImport } from './routes/version.route'
import { Route as TimelineRouteRouteImport } from './routes/timeline.route'
import { Route as TestRouteRouteImport } from './routes/test.route'
import { Route as SlackNewsRouteRouteImport } from './routes/slack-news.route'
import { Route as OrgchartRouteRouteImport } from './routes/orgchart.route'
import { Route as GithubNewsRouteRouteImport } from './routes/github-news.route'
import { Route as FlowRouteRouteImport } from './routes/flow.route'
import { Route as DrawRouteRouteImport } from './routes/draw.route'
import { Route as IndexRouteRouteImport } from './routes/index.route'
import { Route as AdminIndexRouteRouteImport } from './routes/admin/index.route'
import { Route as MemberMemberIdRouteRouteImport } from './routes/member/$memberId.route'
import { Route as AuthSignupRouteRouteImport } from './routes/auth/signup.route'
import { Route as AuthSigninRouteRouteImport } from './routes/auth/signin.route'
import { Route as AuthResetPasswordRouteRouteImport } from './routes/auth/reset-password.route'
import { Route as AdminUsersRouteRouteImport } from './routes/admin/users.route'
import { Route as AdminIntegrationsRouteRouteImport } from './routes/admin/integrations.route'
import { Route as AdminAnalyticsRouteRouteImport } from './routes/admin/analytics.route'

const WorkstreamsRouteRoute = WorkstreamsRouteRouteImport.update({
  id: '/workstreams',
  path: '/workstreams',
  getParentRoute: () => rootRouteImport,
} as any)
const VersionRouteRoute = VersionRouteRouteImport.update({
  id: '/version',
  path: '/version',
  getParentRoute: () => rootRouteImport,
} as any)
const TimelineRouteRoute = TimelineRouteRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => rootRouteImport,
} as any)
const TestRouteRoute = TestRouteRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const SlackNewsRouteRoute = SlackNewsRouteRouteImport.update({
  id: '/slack-news',
  path: '/slack-news',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgchartRouteRoute = OrgchartRouteRouteImport.update({
  id: '/orgchart',
  path: '/orgchart',
  getParentRoute: () => rootRouteImport,
} as any)
const GithubNewsRouteRoute = GithubNewsRouteRouteImport.update({
  id: '/github-news',
  path: '/github-news',
  getParentRoute: () => rootRouteImport,
} as any)
const FlowRouteRoute = FlowRouteRouteImport.update({
  id: '/flow',
  path: '/flow',
  getParentRoute: () => rootRouteImport,
} as any)
const DrawRouteRoute = DrawRouteRouteImport.update({
  id: '/draw',
  path: '/draw',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRouteRoute = IndexRouteRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRouteRoute = AdminIndexRouteRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const MemberMemberIdRouteRoute = MemberMemberIdRouteRouteImport.update({
  id: '/member/$memberId',
  path: '/member/$memberId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRouteRoute = AuthSignupRouteRouteImport.update({
  id: '/auth/signup',
  path: '/auth/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRouteRoute = AuthSigninRouteRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRouteRoute = AuthResetPasswordRouteRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRouteRoute = AdminUsersRouteRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIntegrationsRouteRoute = AdminIntegrationsRouteRouteImport.update({
  id: '/admin/integrations',
  path: '/admin/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnalyticsRouteRoute = AdminAnalyticsRouteRouteImport.update({
  id: '/admin/analytics',
  path: '/admin/analytics',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRouteRoute
  '/draw': typeof DrawRouteRoute
  '/flow': typeof FlowRouteRoute
  '/github-news': typeof GithubNewsRouteRoute
  '/orgchart': typeof OrgchartRouteRoute
  '/slack-news': typeof SlackNewsRouteRoute
  '/test': typeof TestRouteRoute
  '/timeline': typeof TimelineRouteRoute
  '/version': typeof VersionRouteRoute
  '/workstreams': typeof WorkstreamsRouteRoute
  '/admin/analytics': typeof AdminAnalyticsRouteRoute
  '/admin/integrations': typeof AdminIntegrationsRouteRoute
  '/admin/users': typeof AdminUsersRouteRoute
  '/auth/reset-password': typeof AuthResetPasswordRouteRoute
  '/auth/signin': typeof AuthSigninRouteRoute
  '/auth/signup': typeof AuthSignupRouteRoute
  '/member/$memberId': typeof MemberMemberIdRouteRoute
  '/admin': typeof AdminIndexRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRouteRoute
  '/draw': typeof DrawRouteRoute
  '/flow': typeof FlowRouteRoute
  '/github-news': typeof GithubNewsRouteRoute
  '/orgchart': typeof OrgchartRouteRoute
  '/slack-news': typeof SlackNewsRouteRoute
  '/test': typeof TestRouteRoute
  '/timeline': typeof TimelineRouteRoute
  '/version': typeof VersionRouteRoute
  '/workstreams': typeof WorkstreamsRouteRoute
  '/admin/analytics': typeof AdminAnalyticsRouteRoute
  '/admin/integrations': typeof AdminIntegrationsRouteRoute
  '/admin/users': typeof AdminUsersRouteRoute
  '/auth/reset-password': typeof AuthResetPasswordRouteRoute
  '/auth/signin': typeof AuthSigninRouteRoute
  '/auth/signup': typeof AuthSignupRouteRoute
  '/member/$memberId': typeof MemberMemberIdRouteRoute
  '/admin': typeof AdminIndexRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRouteRoute
  '/draw': typeof DrawRouteRoute
  '/flow': typeof FlowRouteRoute
  '/github-news': typeof GithubNewsRouteRoute
  '/orgchart': typeof OrgchartRouteRoute
  '/slack-news': typeof SlackNewsRouteRoute
  '/test': typeof TestRouteRoute
  '/timeline': typeof TimelineRouteRoute
  '/version': typeof VersionRouteRoute
  '/workstreams': typeof WorkstreamsRouteRoute
  '/admin/analytics': typeof AdminAnalyticsRouteRoute
  '/admin/integrations': typeof AdminIntegrationsRouteRoute
  '/admin/users': typeof AdminUsersRouteRoute
  '/auth/reset-password': typeof AuthResetPasswordRouteRoute
  '/auth/signin': typeof AuthSigninRouteRoute
  '/auth/signup': typeof AuthSignupRouteRoute
  '/member/$memberId': typeof MemberMemberIdRouteRoute
  '/admin/': typeof AdminIndexRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/draw'
    | '/flow'
    | '/github-news'
    | '/orgchart'
    | '/slack-news'
    | '/test'
    | '/timeline'
    | '/version'
    | '/workstreams'
    | '/admin/analytics'
    | '/admin/integrations'
    | '/admin/users'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/member/$memberId'
    | '/admin'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/draw'
    | '/flow'
    | '/github-news'
    | '/orgchart'
    | '/slack-news'
    | '/test'
    | '/timeline'
    | '/version'
    | '/workstreams'
    | '/admin/analytics'
    | '/admin/integrations'
    | '/admin/users'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/member/$memberId'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/draw'
    | '/flow'
    | '/github-news'
    | '/orgchart'
    | '/slack-news'
    | '/test'
    | '/timeline'
    | '/version'
    | '/workstreams'
    | '/admin/analytics'
    | '/admin/integrations'
    | '/admin/users'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/member/$memberId'
    | '/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRouteRoute: typeof IndexRouteRoute
  DrawRouteRoute: typeof DrawRouteRoute
  FlowRouteRoute: typeof FlowRouteRoute
  GithubNewsRouteRoute: typeof GithubNewsRouteRoute
  OrgchartRouteRoute: typeof OrgchartRouteRoute
  SlackNewsRouteRoute: typeof SlackNewsRouteRoute
  TestRouteRoute: typeof TestRouteRoute
  TimelineRouteRoute: typeof TimelineRouteRoute
  VersionRouteRoute: typeof VersionRouteRoute
  WorkstreamsRouteRoute: typeof WorkstreamsRouteRoute
  AdminAnalyticsRouteRoute: typeof AdminAnalyticsRouteRoute
  AdminIntegrationsRouteRoute: typeof AdminIntegrationsRouteRoute
  AdminUsersRouteRoute: typeof AdminUsersRouteRoute
  AuthResetPasswordRouteRoute: typeof AuthResetPasswordRouteRoute
  AuthSigninRouteRoute: typeof AuthSigninRouteRoute
  AuthSignupRouteRoute: typeof AuthSignupRouteRoute
  MemberMemberIdRouteRoute: typeof MemberMemberIdRouteRoute
  AdminIndexRouteRoute: typeof AdminIndexRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workstreams': {
      id: '/workstreams'
      path: '/workstreams'
      fullPath: '/workstreams'
      preLoaderRoute: typeof WorkstreamsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/version': {
      id: '/version'
      path: '/version'
      fullPath: '/version'
      preLoaderRoute: typeof VersionRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/timeline': {
      id: '/timeline'
      path: '/timeline'
      fullPath: '/timeline'
      preLoaderRoute: typeof TimelineRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/slack-news': {
      id: '/slack-news'
      path: '/slack-news'
      fullPath: '/slack-news'
      preLoaderRoute: typeof SlackNewsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orgchart': {
      id: '/orgchart'
      path: '/orgchart'
      fullPath: '/orgchart'
      preLoaderRoute: typeof OrgchartRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/github-news': {
      id: '/github-news'
      path: '/github-news'
      fullPath: '/github-news'
      preLoaderRoute: typeof GithubNewsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flow': {
      id: '/flow'
      path: '/flow'
      fullPath: '/flow'
      preLoaderRoute: typeof FlowRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/draw': {
      id: '/draw'
      path: '/draw'
      fullPath: '/draw'
      preLoaderRoute: typeof DrawRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/member/$memberId': {
      id: '/member/$memberId'
      path: '/member/$memberId'
      fullPath: '/member/$memberId'
      preLoaderRoute: typeof MemberMemberIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/integrations': {
      id: '/admin/integrations'
      path: '/admin/integrations'
      fullPath: '/admin/integrations'
      preLoaderRoute: typeof AdminIntegrationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/admin/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRouteRoute: IndexRouteRoute,
  DrawRouteRoute: DrawRouteRoute,
  FlowRouteRoute: FlowRouteRoute,
  GithubNewsRouteRoute: GithubNewsRouteRoute,
  OrgchartRouteRoute: OrgchartRouteRoute,
  SlackNewsRouteRoute: SlackNewsRouteRoute,
  TestRouteRoute: TestRouteRoute,
  TimelineRouteRoute: TimelineRouteRoute,
  VersionRouteRoute: VersionRouteRoute,
  WorkstreamsRouteRoute: WorkstreamsRouteRoute,
  AdminAnalyticsRouteRoute: AdminAnalyticsRouteRoute,
  AdminIntegrationsRouteRoute: AdminIntegrationsRouteRoute,
  AdminUsersRouteRoute: AdminUsersRouteRoute,
  AuthResetPasswordRouteRoute: AuthResetPasswordRouteRoute,
  AuthSigninRouteRoute: AuthSigninRouteRoute,
  AuthSignupRouteRoute: AuthSignupRouteRoute,
  MemberMemberIdRouteRoute: MemberMemberIdRouteRoute,
  AdminIndexRouteRoute: AdminIndexRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
